import { ConnectJournalConstants } from './ConnectJournal.constants';

const initialState = {
  global: {
    data: []
  },
  workspace: {
    data: []
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ConnectJournalConstants.GET_CONNECT_JOURNAL_GLOBAL_REQUEST:
      return {
        ...state,
        global: {
          loading: true,
          error: false
        }
      };
    case ConnectJournalConstants.GET_CONNECT_JOURNAL_GLOBAL_SUCCESS:
      return {
        ...state,
        global: {
          loading: false,
          error: false,
          data: action.payload,
          lastUpdatedChannelList: action.list,
          isDataAvailable: action.isDataAvailable,
          inProgressDataAvailable: action.inProgressDataAvailable
        }
      };
    case ConnectJournalConstants.GET_CONNECT_JOURNAL_GLOBAL_ERROR:
      return {
        ...state,
        global: {
          loading: false,
          error: true
        }
      };
    case ConnectJournalConstants.GET_CONNECT_JOURNAL_WORKSPACE_REQUEST:
      return {
        ...state,
        workspace: {
          loading: true,
          error: false
        }
      };
    case ConnectJournalConstants.GET_CONNECT_JOURNAL_WORKSPACE_SUCCESS:
      return {
        ...state,
        workspace: {
          loading: false,
          error: false,
          data: action.payload
        }
      };
    case ConnectJournalConstants.GET_CONNECT_JOURNAL_WORKSPACE_ERROR:
      return {
        ...state,
        workspace: {
          loading: false,
          error: true
        }
      };
    default:
      return {
        ...state
      };
  }
}
